export const imageToPreload = [
  'icn-ledger.svg',
  'icn-metamask.svg',
  'trezor-logo.png',
  'metamask-connect-in-progress.png',
  'metamask-sign-in-progress.png',
  'trezor-connect-in-progress.png',
  'trezor-sign-in-progress.png',
  'ledger-connect-in-progress.png',
  'ledger-sign-in-progress.png',
];
